import { memo, SelectHTMLAttributes } from "react";

import "./index.scss";

interface InputSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  label: string;
  list: any;
  className?: string;
  value: any;
  onChange?: any;
  onBlur?: any;
  disabled?: boolean;
  placeholder?: string;
  required?: boolean;
  errorMessage?: string;
  errorStatus?: boolean;
  addNewField?: { label: string; value: number };
  onClick?: any;
}

function InputSelect({
  label,
  list,
  className,
  value,
  onChange,
  onBlur,
  name,
  disabled,
  placeholder,
  required,
  errorStatus,
  errorMessage,
  addNewField,
  onClick,
  ...rest
}: InputSelectProps) {
  return (
    <div className={`select-component ${className}`}>
      <label className="select-component__label">
        {label}
        {required ? <span className="text-red-500"> *</span> : ""}
      </label>
      <select
        name={name}
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        className={`select-component__select ${disabled ? "select-component__select__disabled" : ""}`}
        {...rest}
      >
        {list?.length && list?.map((item: any, index: number) => {
          return (
            <>
              {index === 0 && (
                <option disabled value={0} key={item.id + placeholder}>
                  {placeholder ? placeholder : "Selecione"}
                </option>
              )}
              <option key={item.id} value={Number(item?.id) || item.value}>
                {item?.name || item.label}
              </option>
            </>
          );
        })}
        {addNewField && (
          <option value={addNewField?.value} className="bg-primary new-field">
            + {addNewField?.label}
          </option>
        )}
      </select>
      {errorStatus && <span className={`errorStatus`}>{errorMessage}</span>}
    </div>
  );
}

export default memo(InputSelect);
